<template>
    <div class="index-hero-slide" :style="backgroundStyle">
        <div class="index-hero-slide__content">
            <h2 class="index-hero-slide__title">
                {{ slide.title }}
            </h2>
            <div class="index-hero-slide__text">
                {{ slide.description }}
            </div>

            <UiButton class="index-hero-slide__button" :to="slide.link.href">
                {{ slide.link.text }}
            </UiButton>
        </div>
        <div class="index-hero-slide__image">
            <div class="index-hero-slide__image-wrapper" :style="imageStyle" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { IndexHeroSlide } from '~/src/shared/types/index-page'

    const props = defineProps<{
        slide: IndexHeroSlide
    }>()

    const backgroundStyle = computed(() => ({
        '--mobile-gradient': props.slide.background.mobile,
        '--tablet-gradient': props.slide.background.tablet,
        '--desktop-gradient': props.slide.background.desktop
    }))
    const imageStyle = computed(() => ({
        '--image-tablet-url': `url(${props.slide.img.tablet})`,
        '--image-desktop-url': `url(${props.slide.img.desktop})`
    }))
</script>

<style scoped lang="scss">
.index-hero-slide {
        position: relative;
        display: flex;
        width: 100%;
        background: var(--desktop-gradient);

        @include respond-to(tablet) {
            flex-flow: column;
            background: var(--tablet-gradient);
        }

        @include respond-to(mobile) {
            background: var(--mobile-gradient);
        }

        &__content {
            position: relative;
            z-index: 1;
            display: flex;
            align-items: flex-start;
            flex-flow: column;
            gap: 24px;
            max-width: calc(573px + 60px);
            padding-top: 120px;
            padding-left: 60px;
            color: var(--white);

            @include respond-to(tablet) {
                max-width: 100%;
                padding: 48px 40px 0;
                gap: 16px;
            }

            @include respond-to(mobile) {
                gap: 24px;
                padding: 32px 24px 0;
            }
        }

        &__title {
            @include mulish40b;

            @include respond-to(tablet) {
                @include mulish32b;
            }

            @include respond-to(mobile) {
                @include mulish24b;
            }
        }

        &__text {
            @include manrope17r;
        }

        &__image {
            position: absolute;
            right: 0;
            width: 100%;
            max-width: 700px;
            height: 100%;

            @include respond-to(tablet) {
                position: relative;
                width: max(311px, 74.2897%);
                height: 523px;
                margin: 0 auto;
            }

            @include respond-to(mobile) {
                width: 85%;
            }
        }

        &__image-wrapper {
            width: 100%;
            height: 100%;
            background: var(--image-desktop-url) no-repeat center / cover;

            @include respond-to(tablet) {
                background: var(--image-tablet-url) no-repeat center / cover;
            }
        }
    }
</style>
